export const saveService = [
  '',
  `mutation saveContentService($input: ServizioInput!) {
    saveContentService(service:$input) {
        id
      }
    }`,
  'saveContentService',
];
